const actions = {
  // Listar
  listarCentroDeCustos: async (
    context,
    { per_page, vendor_id, page, search }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`cost-centers`, {
      params: {
        per_page,
        vendor_id,
        page,
        search,
      },
    });

    return response;
  },

  criarCentroDeCusto: async (context, { vendor_id, code, conta, name }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(`vendors/${vendor_id}/cost-centers`, {
      code,
      conta,
      name,
    });

    return response;
  },

  deletarCentroDeCusto: async (context, { cost_center_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.delete(`cost-centers/${cost_center_id}`);

    return response;
  },

  // Detalhar Centro de Custo

  detalharCentroDeCusto: async (context, { cost_center_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`cost-centers/${cost_center_id}`);

    return response;
  },

  listarUsuariosDoCentroDeCusto: async (context, { cost_center_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`cost-centers/${cost_center_id}/people`);

    return response;
  },

  alterarDadosCentroDeCusto: async (
    context,
    { cc_id, code, conta, name, owner_id }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`cost-centers/${cc_id}`, {
      code,
      conta,
      name,
      owner_id,
    });

    return response;
  },

  listarUsuariosDonos: async (context, { per_page, search }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`auth/users`, {
      params: {
        per_page,
        search,
      },
    });

    return response;
  },

  listarCentroEspecifico: async (context, { id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`cost-centers/${id}`);

    return response;
  },

  listarGrupos: async (context, { per_page, vendor_id, page, search }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`product-groups`, {
      params: {
        per_page,
        vendor_id,
        page,
        search,
      },
    });

    return response;
  },

  produtosGrupo: async (context, { group_id, search, unidade }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`contracts/${unidade}`, {
      params: {
        group_id,
        search,
      },
    });

    return response;
  },

  grupoCentros: async (context, { search, id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`cost-centers/${id}/product-groups`, {
      params: {
        search,
      },
    });

    return response;
  },

  deletarGrupoRegra: async (context, { id, centroId }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.delete(
      `product-groups/${centroId}/cost-centers/${id}`
    );

    return response;
  },

  criarRegra: async (
    context,
    {
      minimum_days,
      maximum_days,
      amount,
      description,
      group_id,
      cost_center_id,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`product-groups/${group_id}/cost-centers`, {
      minimum_days,
      maximum_days,
      amount,
      description,
      group_id,
      cost_center_id,
    });

    return response;
  },

  indexar: async (context, { centrosDeCusto }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(`/regra/reindexar-usuarios`, {
      centrosDeCusto,
    });

    return response;
  },
};

export const centroDeCusto = {
  namespaced: true,
  actions,
};
